module.exports = __webpack_public_path__ + "img/banner@2x - 副本.8d77c808.png";